module.exports = __webpack_public_path__ + "media/images/shop/kodawari1-03efac077ec450edd75b0a260a211639.jpg";